import React, { useCallback, useRef, useState } from 'react';
import { debounce } from 'lodash';
import NewSpinner from '../NewSpinner/NewSpinner';

const InfiniteScroll = ({
  children,
  bottomLocation = 0,
  debounceTime = 500,
  handleScrollsuccess,
  disable = false,
  pageInfo = {},
  showDefaultLoader = true,
  includeFilterLoder = false
}) => {
  const scrollDiv = useRef();
  const [resolvingPromise, setResolvingPromise] = useState(false);

  const scrollLocationReached = async () => {
    setResolvingPromise(true);
    if (typeof handleScrollsuccess == 'function') {
      await handleScrollsuccess();
    }
    setResolvingPromise(false);
  };

  const handleScroll = () => {
    if (pageInfo?.number >= pageInfo?.totalPages - 1) return;
    if (resolvingPromise || disable) return;
    if (
      scrollDiv?.current?.scrollHeight -
        (scrollDiv?.current?.scrollTop + scrollDiv?.current?.clientHeight) <=
      bottomLocation
    ) {
      scrollLocationReached();
    }
  };

  const onScroll = useCallback(debounce(handleScroll, debounceTime), [
    resolvingPromise,
    disable,
    pageInfo
  ]);

  return (
    <div className="w-full">
      <div
        className="w-full max-h-screen overflow-auto"
        onScroll={e => {
          if (resolvingPromise) e.stopPropagation();
          onScroll();
        }}
        ref={scrollDiv}
      >
        <div className="w-full">{children}</div>
      </div>
      {((showDefaultLoader && resolvingPromise) ||
        (showDefaultLoader && includeFilterLoder)) && (
        <div className=" bg-transparent py-4 w-full text-center mx-auto mt-5 ">
          <div className="table mx-auto">
            <NewSpinner />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfiniteScroll;
